import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import useFormHook from '@shared/hooks/useFormHook';
import { notifySuccess } from '@config/tostifyConfig/tostifyConfig';

export default function BanksForm({ onClose, onConfirm, editData, formProps }) {
    const { t } = useTranslation();
    const { modalRef } = useFormHook({}, onClose);
    const { register, handleSubmit, errors } = formProps;

    const submitForm = async (data) => {
        if (onConfirm) {
            await onConfirm(data);
            notifySuccess(t('persons.banks.success'));
        }else{
            notifyError(t('persons.banks.error'));
        }
    };

    return (
        <div className="modal show" tabIndex="-1">
            <div className="modal-dialog modal-confirm" ref={modalRef}>
                <div className="modal-content">
                    <button type="button" className="close" onClick={onClose}>
                        <FontAwesomeIcon icon={faTimes} />
                    </button>
                    <div className="modal-body">
                        <h4 className="modal-title">
                            {editData ? t('common.edit') : t('common.add')} {t('persons.banks.title')}
                        </h4>
                        <form id="banksForm" className="region-form" onSubmit={handleSubmit(submitForm)}>
                            <div className="form-group">
                                <span className="span-bold">BIC <span className="required">*</span></span>
                                <input
                                    type="text"
                                    className={`form-control ${errors.bankCode ? 'is-invalid' : ''}`}
                                    {...register('bankCode')}
                                />
                                {errors.bankCode && (
                                    <div className="invalid-feedback">{errors.bankCode.message}</div>
                                )}
                            </div>

                            <div className="form-group">
                                <span className="span-bold">{t('persons.banks.name')} <span className="required">*</span></span>
                                <input
                                    type="text"
                                    className={`form-control ${errors.name ? 'is-invalid' : ''}`}
                                    {...register('name')}
                                />
                                {errors.name && (
                                    <div className="invalid-feedback">{errors.name.message}</div>
                                )}
                            </div>

                            <div className="form-group">
                                <span className="span-bold">{t('persons.banks.address')}</span>
                                <input
                                    type="text"
                                    className={`form-control ${errors.address ? 'is-invalid' : ''}`}
                                    {...register('address')}
                                />
                                {errors.address && (
                                    <div className="invalid-feedback">{errors.address.message}</div>
                                )}
                            </div>

                            {/* <div className="form-group"> */}
                                <div className="input-checkbox-wrapper">
                                    <input
                                        type="checkbox"
                                        id="bank-active"
                                        {...register('active')}
                                    />
                                    <label htmlFor="bank-active">{t('persons.banks.active', 'Банката е активна')}</label>
                                </div>
                            {/* </div> */}
                        </form>
                    </div>
                    <div className="modal-footer">
                        <button type="submit" form="banksForm" className="btn btn-primary">
                            {t('common.save')}
                        </button>
                        <button type="button" className="btn btn-secondary" onClick={onClose}>
                            {t('common.cancel')}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}